var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A0A1A1",
    fillRule: "evenodd",
    d: "m13.225 13.754 4.581 4.581a.967.967 0 0 1-.007 1.371.97.97 0 0 1-1.37.007l-4.756-4.755a7.6 7.6 0 0 1-3.88 1.062C3.49 16.02 0 12.434 0 8.01S3.49 0 7.794 0s7.793 3.586 7.793 8.01a8.1 8.1 0 0 1-2.362 5.744m-5.431.263c3.228 0 5.845-2.69 5.845-6.007 0-3.318-2.617-6.008-5.845-6.008-3.229 0-5.846 2.69-5.846 6.008s2.617 6.007 5.846 6.007"
  })));
});
const SvgTbSearchGreyIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTbSearchGreyIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTkgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPjY2RDI0MTlFLUFFNTAtNEMyMC1BNTEyLUMwRTVENEJDMTk4MjwvdGl0bGU+PHBhdGggZD0iTTEzLjIyNSAxMy43NTRsNC41ODEgNC41ODFhLjk2Ny45NjcgMCAwIDEtLjAwNyAxLjM3MS45NzEuOTcxIDAgMCAxLTEuMzcuMDA3bC00Ljc1Ni00Ljc1NWE3LjU5NyA3LjU5NyAwIDAgMS0zLjg4IDEuMDYyQzMuNDkgMTYuMDIgMCAxMi40MzQgMCA4LjAxIDAgMy41ODYgMy40OSAwIDcuNzk0IDBjNC4zMDQgMCA3Ljc5MyAzLjU4NiA3Ljc5MyA4LjAxIDAgMi4yNTMtLjkwNSA0LjI4OS0yLjM2MiA1Ljc0NHptLTUuNDMxLjI2M2MzLjIyOCAwIDUuODQ1LTIuNjkgNS44NDUtNi4wMDcgMC0zLjMxOC0yLjYxNy02LjAwOC01Ljg0NS02LjAwOC0zLjIyOSAwLTUuODQ2IDIuNjktNS44NDYgNi4wMDhzMi42MTcgNi4wMDcgNS44NDYgNi4wMDd6IiBmaWxsPSIjQTBBMUExIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4K";